import { Alt1 } from "../../Alt1";
export class Alt1GLProgram {
    constructor(vertex_shader, fragment_shader, inputs, uniforms) {
        this.vertex_shader = vertex_shader;
        this.fragment_shader = fragment_shader;
        this.inputs = inputs;
        this.uniforms = uniforms;
        this.program = Alt1.instance().opengl().get().createProgram(this.vertex_shader, this.fragment_shader, this.inputs, this.uniforms);
    }
    get() {
        return this.program;
    }
}
